import { Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { WorkService } from '../../services/work.service';
import { Router } from '@angular/router';
import { getISOWeek } from 'date-fns';

@Component({
  selector: 'app-addworkreport',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.less']
})
export class AddWorkreportComponent implements OnInit {

  isCollapsed = false;
  formData: any = {
    problem:"Không có vấn đề, công việc diễn ra tốt đẹp",
    suggestion: "Không có đề xuất hoặc kiến nghị"
  };
  perPage = 10;
  page = 1;
  dataCalendar:any = [];
  currentYear = new Date().getFullYear();
  yearSelect = new Date().getFullYear();
  monthSelect = (new Date().getMonth() + 1).toString();
  weekSelect = getISOWeek(new Date());
  calendarSelect: any = [];
  isLoading = false;
  rewriteContentLoading= false;
  editor1 = false;
  editor2 = false;
  editor3 = false;
  editor4 = false;
  editor5 = false;

  constructor(
    private workService: WorkService,
    private message: NzMessageService,
    public router:Router,
  ) { }

  getCalendar(){
    this.workService.getCalendar(this.yearSelect).subscribe((res)=>{
      this.dataCalendar = res.data.docs;
      if(this.calendarSelect){
        this.calendarSelect._id = null;
      }      
      this.handleWeekChange(getISOWeek(new Date()))
    })
  }

  postReport(data:any){    
    this.isLoading = true;
    this.workService.postReport(data).subscribe(
      res => {
        console.log('res', res);
        this.message.success('Đã gửi báo cáo thành công!')
        this.router.navigate(['/report']);
        this.isLoading = false;
      },
      err => {
        console.log('err', err);
        this.message.error('Không thể gửi báo cáo, vui lòng thử lại!')
        this.isLoading = false;
      }
    )
  }

  handleWeekChange(selectedValue: any){
    this.workService.getCalendarWeek(selectedValue, this.yearSelect).subscribe((res)=>{      
      this.calendarSelect = res.data.docs[0];      
    })
  }

  handleYearChange(){
    this.weekSelect = null;
    this.calendarSelect = [];
    this.getCalendar();
  }

  onSubmit() {    
    if(this.calendarSelect == undefined || this.weekSelect == null){
      this.message.warning('Chưa chọn tuần')
      return
    }
    this.formData.calendar = this.calendarSelect._id;
    if (!this.formData.calendar){
      this.message.warning('Chưa chọn tuần')
    }else{            
      this.postReport(this.formData);
    };
  }

  setActiveEditor(editorNumber: number): void {
    this.editor1 = false;
    this.editor2 = false;
    this.editor3 = false;
    this.editor4 = false;
    switch (editorNumber) {
      case 1:
        this.editor1 = true;
        break;
      case 2:
        this.editor2 = true;
        break;
      case 3:
        this.editor3 = true;
        break;
      case 4:
        this.editor4 = true;
        break;
      default:
        break;
    }
  }

  

  rewriteContent() {
    this.rewriteContentLoading = true;

    const prompt = `Hãy viết lại nội dung dưới đây sao cho chuyên nghiệp, rõ ràng, phù hợp với định dạng báo cáo công việc hàng tuần. Mỗi hạng mục công việc cần phải có đầy đủ các phần:

    - **Thời gian thực hiện là đúng tiến độ**
    - **Kết quả đạt được**
    - **Minh chứng (nếu có)**
    
    Trình bày nội dung dưới dạng HTML với các yếu tố sau:
    
    1. Sử dụng thẻ tiêu đề h3 và in đậm để làm rõ các hạng mục.
    2. Dùng **danh sách có thứ tự hoặc không thứ tự** để liệt kê các phần công việc.
    3. **In đậm các tiêu đề quan trọng** (ví dụ: Thời gian thực hiện, Kết quả, Minh chứng).
    4. Cung cấp kết quả dưới dạng HTML sạch, dễ hiểu và phù hợp để hiển thị trong Quill Editor.
       
    Lưu ý: Không bao gồm thẻ \`\`\`html hoặc bất kỳ chú thích nào trong nội dung trả về. Nội dung cần viết lại là:
    
    ${this.formData.work_this_week}`;    

  
    fetch('https://openrouter.ai/api/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer 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',
      },
      body: JSON.stringify({
        model: 'openai/gpt-4o',
        messages: [
          { role: 'system', content: 'Bạn là một chuyên gia chỉnh sửa văn bản.' },
          { role: 'user', content: prompt },
        ],
        temperature: 0.7,
        max_tokens: 1000,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        this.rewriteContentLoading = false;
        this.formData.work_this_week = data.choices[0].message.content;
      })
      .catch((err) => {
        console.error('Lỗi gọi AI:', err);
        this.rewriteContentLoading = false;
      })
  }
 
  ngOnInit() {
    this.getCalendar();
  }

}
